import { render, staticRenderFns } from "./SyncContact.vue?vue&type=template&id=b9d38d96&"
import script from "./SyncContact.vue?vue&type=script&lang=js&"
export * from "./SyncContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports